// extracted by mini-css-extract-plugin
export default {"dark":"SemiPie_dark__qtrcU","light":"SemiPie_light__AwTiA"};